<template>
  <div :class="$style.container" @keydown.enter="handleSubmit('distructor')">
    <Form :model="form" label-position="left" :label-width="0" class="distructorLogin" ref="distructor" :rules="rules">
        <FormItem prop="account">
          <Input v-model="form.account" placeholder="输入分销商账号/手机号"/>
        </FormItem>
        <FormItem prop="password">
          <Input v-model="form.password" type="password" placeholder="输入登录密码"/>
        </FormItem>
        <FormItem :class="$style.tip">
          <Checkbox v-model="single">记住密码</Checkbox>
        </FormItem>
        <FormItem style="margin-top: 30px;">
          <Button type="primary" @click.stop="handleSubmit('distructor')">登录</Button>
        </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
   props: {
    isSelect: {
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      form:{
        account:'',
        password: ''
      },
      single: false,
      rules: {
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      }
    };
  },
  watch: {
    isSelect:{
       handler (newValue) {
        this.single = newValue
        if (newValue) {
          let obj = JSON.parse(sessionStorage.getItem("disbutorInfo")) || {}
          this.form.account = obj.usid
          this.form.password = obj.pwd
        }
      },
      immediate:true
    }
  },
  methods: {
    // 登录
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('login',{account:this.form.account,password: this.form.password ,isSelect: this.single}, '01')
        } else {
         return false
        }
      })
    },
    // 重置表单
    resetForm () {
      this.form ={
        account:'',
        password: ''
      }
    }
  }
};
</script> 
<style lang="less" module>
.container {
  form {
    width: 300px;
    margin: 0 auto;
  }
  input {
    width:100%;
    border: none;
    border-bottom: 1px solid #B4CAF7;
    font-size:14px;
  }
  button {
    width: 100%;
    height: 40px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    background: #4B7FF0;
  }
  .tip {
    margin-top: 20px!important;
  }
}
</style>

<style scoped>
  .distructorLogin >>> .ivu-form-item {
    margin-top: 40px;
    margin-bottom: 0px;
  }
  .distructorLogin >>> .ivu-input:hover, .distructorLogin >>> .ivu-input:focus {
    border-color: #B4CAF7;
    border-bottom: 1px solid #B4CAF7;
    box-shadow:none;
  }
  .distructorLogin >>> .ivu-form-item-error .ivu-input {
    border:none;
    border-bottom: 1px solid #B4CAF7;
  }
</style>